import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAppleAlt,
  faShoppingBasket,
  faCow,
  faCheese,
  faCandyCane,
  faUtensils,
  faSeedling,
  faSprayCanSparkles,
  faWineBottle,
  faDog
} from '@fortawesome/free-solid-svg-icons';

export default function Productos() {
  return (
    <section className="bg-[#f28c281a] py-12 px-6">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-semibold mb-10 text-[#0033A0] text-center">Nuestros Productos</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">

          {/* Frutas y Verduras */}
          <ProductoCard icon={faAppleAlt} titulo="Frutas y Verduras" descripcion="Productos frescos del día, seleccionados con cuidado para garantizar calidad, sabor y valor nutricional para ti y tu familia. Todo directo del campo a tu mesa." />

          {/* Abarrotes */}
          <ProductoCard icon={faShoppingBasket} titulo="Abarrotes" descripcion="Desde básicos hasta especiales: enlatados, aceites, galletas, pastas y más para tu despensa." />

          {/* Lácteos */}
          <ProductoCard icon={faCow} titulo="Lácteos" descripcion="Leche, yogurt, mantequilla y otros derivados lácteos con la frescura y calidad que tu familia merece cada día." />

          {/* Cremería */}
          <ProductoCard icon={faCheese} titulo="Cremería" descripcion="Quesos, crema, requesón y más para enriquecer tus platillos." />

          {/* Dulcería */}
          <ProductoCard icon={faCandyCane} titulo="Dulcería" descripcion="Dulces típicos y modernos para grandes y chicos. Surtido ideal para fiestas." />

          {/* Desechables */}
          <ProductoCard icon={faUtensils} titulo="Desechables" descripcion="Vasos, platos, servilletas y utensilios para eventos o uso diario." />

          {/* Granos y Cereales */}
          <ProductoCard icon={faSeedling} titulo="Granos y Cereales" descripcion="Arroz, avena, lentejas, frijol y más. Alimentos básicos y nutritivos." />

          {/* Limpieza */}
          <ProductoCard icon={faSprayCanSparkles} titulo="Limpieza" descripcion="Productos eficaces para mantener limpio tu hogar o negocio." />

          {/* Vinos y Licores */}
          <ProductoCard icon={faWineBottle} titulo="Vinos y Licores" descripcion="Cervezas, tequilas y vinos nacionales e importados para toda ocasión." />

          {/* Mascotas */}
          <ProductoCard icon={faDog} titulo="Mascotas" descripcion="Alimento, snacks y artículos esenciales para perros, gatos y aves." />

        </div>
      </div>
    </section>
  );
}

// Subcomponente reutilizable para cada tarjeta
function ProductoCard({ icon, titulo, descripcion }) {
  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-2xl transition">
      <div className="flex items-center mb-4 text-[#F28C28]">
        <FontAwesomeIcon icon={icon} className="text-3xl mr-3" />
        <h3 className="text-xl font-bold">{titulo}</h3>
      </div>
      <p className="text-gray-700">{descripcion}</p>
    </div>
  );
}
